/**
 * The dose a return already provides for a medicine, so the cleanroom draws only the missing
 * part. The picking list matched the return to one medicine by prescribed name; returns saved
 * before that match existed carry no amount and are ignored (the preparation is top-up only).
 */
export function returnProvidedDose(returns, medicine, medicineCount) {
    if (!medicine)
        return 0;
    let total = 0;
    for (const ret of returns ?? []) {
        if (!ret.providedAmount || ret.providedAmount <= 0)
            continue;
        if (ret.prescribedNameId) {
            if (ret.prescribedNameId === medicine.prescribedNameId)
                total += ret.providedAmount;
        }
        else if (medicineCount === 1) {
            total += ret.providedAmount;
        }
    }
    return total;
}
//# sourceMappingURL=return-dose.js.map